module.exports = __webpack_public_path__ + "static/media/logo.1fb0b2a0.png";